import React from 'react';
import { RouteProp, useIsFocused } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack/src/types';

import { StyleSheet, View } from 'react-native';
import UploadReport from '../components/uploadreport/UploadReport';
import { HomeStackParamList } from '../routes';

export type UploadReportPageProps = {
  navigation: StackNavigationProp<HomeStackParamList, 'UploadReport'>;
  route: RouteProp<HomeStackParamList, 'UploadReport'>;
};

const UploadReportPage = (props: UploadReportPageProps) => {
  const isFocused = useIsFocused();

  return (
    <View style={styles.root}>
      <UploadReport navigation={props.navigation} route={props.route} isFocused={isFocused} />
    </View>
  );
};

export default UploadReportPage;

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: '#fff'
  }
});
